// Un bloc JSON-LD est injecté tel quel dans le HTML, à l'intérieur d'une balise
// <script>. Si une chaîne venant de Strapi contient "</script>", le navigateur
// referme la balise à cet endroit : le bloc devient invalide et le reste du
// texte se retrouve dans le document (données structurées perdues, et une porte
// ouverte à l'injection de balises).
//
// "<" est un échappement JSON parfaitement valide : un parseur JSON-LD
// relit bien un "<", donc le contenu des données structurées est inchangé.
export const escapeJsonLd = (json) => String(json).replace(/</g, "\\u003c");

/** JSON.stringify + échappement, pour construire un bloc <script type="application/ld+json">. */
export const jsonLd = (obj) => escapeJsonLd(JSON.stringify(obj));
